import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { checklistsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import SelectWithInterpolation from '../../../packages/kiti-editor/components/select/SelectWithInterpolation'

const QUERY = gql`
  query Checklists($search: String, $page: Int, $filter: ChecklistFilter) {
    checklists(search: $search, page: $page, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
    }
  }
`

export const useChecklistsLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: checklistsClient })
  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'checklists']))
  }
}

const ChecklistSelect = ({ onChange, onOptionsChange, value, filter, interpolations = [], ...props }) => {
  const getOptions = useChecklistsLoader(filter)
  const [options, setOptions] = React.useState([])
  const Component = !!interpolations.length ? SelectWithInterpolation : Select

  const loadOptions = React.useCallback(
    async (search, page) => {
      const result = await getOptions(search, page)
      setOptions(result)
      return result
    },
    [getOptions]
  )

  React.useEffect(() => {
    if (onOptionsChange) {
      onOptionsChange(options)
    }
  }, [options, onOptionsChange])

  return (
    <Component
      value={value} //
      onChange={onChange}
      options={loadOptions}
      interpolations={interpolations}
      origin="checklist"
      {...props}
    />
  )
}

export default ChecklistSelect
